import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { ResetPasswordPage } from "@/modules/auth/pages/reset-password-page";

const resetPasswordSearchSchema = z.object({
  token: z.string().optional()
});

export const Route = createFileRoute("/auth/reset-password")({
  validateSearch: zodValidator(resetPasswordSearchSchema),
  component: () => (
    <>
      <DocumentTitle
        title="Reset Password"
        description="Reset your LAMPU Seller Center account password."
      />
      <ResetPasswordPage />
    </>
  )
});
